import { Checkbox, Link } from '@kidslabs/mario-nextjs-react-ui-core';
import { type FC, useCallback } from 'react';
import { useTranslation } from 'next-i18next';

import styles from './term-and-policy.module.css';

interface TermAndPolicyProps {
    /** Whether the checkbox is checked */
    checked?: boolean;
    /** Callback when the user toggles the checkbox */
    onCheckedChange?: (checked: boolean) => void;
}

export const TermAndPolicy: FC<TermAndPolicyProps> = ({ checked = false, onCheckedChange }) => {
    const { t } = useTranslation('common');

    const renderTermsOfService = useCallback(() => {
        return (
            <Link href="/dieu-khoan-dich-vu" className={styles.textLink}>
                {t('text_term_of_service', 'Điều khoản Dịch vụ')}
            </Link>
        );
    }, [t]);

    const renderPrivacyPolicy = useCallback(() => {
        return (
            <Link
                href="/chinh-sach-bao-mat"
                target="_blank"
                aria-label="Chính sách bảo mật"
                className={styles.textLink}
            >
                {t('text_privacy_policy', 'Chính sách Bảo mật của ')}
            </Link>
        );
    }, [t]);

    return (
        <div className={styles.container}>
            <Checkbox
                id="term-and-policy"
                checked={checked}
                onCheckedChange={onCheckedChange}
                size="small"
                className={styles.checkbox}
            />
            <label htmlFor="term-and-policy" className={styles.textTermOfService}>
                {t('text_agree_with', 'Tôi đồng ý với')} {renderTermsOfService()} & {renderPrivacyPolicy()}{' '}
                {t('text_of_kidsplaza', 'Kids Plaza.')}
            </label>
        </div>
    );
};
